'use client'

import * as React from 'react'
import { createIcon } from '../utils'

const ReloadIcon = createIcon({
    displayName: 'ReloadIcon',
    viewBox: '0 0 16 16',
    fill: 'none',
    path: (
        <path
            d="M14.6 7.466s-1.337-1.82-2.422-2.907a6 6 0 101.521 5.908m.901-3v-4m0 4h-4"
            stroke="currentColor"
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    ),
})

export default ReloadIcon
